<template>
  <div class="page-box">
    <base-sub-title title="合同变更"></base-sub-title>
    <a-spin :spinning="loading" style="padding:16px">

      <a-divider orientation="left">
        <span class='btn-control text-btn'>填写变更信息</span>
      </a-divider>
      <div style="padding:0 24px" >
        <a-row :gutter="24" style="margin-bottom:16px">
          <a-col :span="24">
            <div class="flex-row" style="align-items: flex-start;">
              <span class="require">入住房间：</span>
              <div>
                <a-input
                  readOnly
                  style="width:500px"
                  @click="chooseRoomShow=true"
                  type="textarea"
                  v-model="data.intoNames"
                  placeholder="请选择房间"
                />
                <div style="font-size:14px;color:#666;margin-top:6px">
                  总建筑面积：{{data.totalArea}} m
                  <sup>2</sup>
                </div>
              </div>
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="24" style="margin-bottom:16px">
          <a-col :span="24">
            <div class="flex-row" style="align-items: flex-start;">
              <span class="require" style="margin-top:8px">变更协议附件：</span>
              <base-upload-file style="flex:1;" :fileList.sync="newFileList" />
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="24" style="margin-bottom:16px">
          <a-col :span="24">
            <div class="flex-row">
              <span class="require">生效时间：</span>
              <a-date-picker
                :defaultValue="data.effectDate?moment(data.effectDate, dateFormat):moment(new Date(),dateFormat)"
                :format="dateFormat"
                @change="onChangeDate"
                placeholder="选择生效时间"
              />
            </div>
          </a-col>
        </a-row>
      </div>
      <a-divider orientation="right">
        <span
          class="btn-control text-btn"
          @click="noRequireShow = !noRequireShow"
        >{{noRequireShow ? '收起' : '展开'}}</span>
      </a-divider>
      <div style="padding:0 16px" v-if="noRequireShow">
        <a-row :gutter="24" style="margin-bottom:16px">
          <a-col :span="6">合同编号：{{data.contractNo}}</a-col>
          <a-col :span="6">承租方：{{data.companyName}}</a-col>
          <a-col :span="6">注册地址：{{data.registerAddr}}</a-col>
          <a-col :span="6">营业执照：{{data.billTaxNo}}</a-col>
        </a-row>
        <a-row :gutter="24" style="margin-bottom:16px">
          <a-col :span="6">法定代表人：{{data.frName}}</a-col>
          <a-col :span="6">法人身份证：{{data.frCard}}</a-col>
          <a-col :span="6">联系人：{{data.name}}</a-col>
          <a-col :span="6">联系方式：{{data.phone}}</a-col>
        </a-row>
        <a-row :gutter="24" style="margin-bottom:16px">
          <a-col :span="24">办公通讯地址：{{data.workAddr}}</a-col>
        </a-row>
        <a-row :gutter="24" style="margin-bottom:16px">
          <a-col :span="6">合同租期：{{data.beginDate}}至{{data.endDate}}</a-col>
          <a-col :span="6">
            租赁期限：
            <template v-if="data.rentDate">
              <span>{{data.rentDate.split(',')[0]}}年</span>
              <span>{{data.rentDate.split(',')[1]}}月</span>
              <span>{{data.rentDate.split(',')[2]}}天</span>
            </template>
          </a-col>
          <a-col :span="6">租金及支付方式：{{data.rentPay}}</a-col>
        </a-row>
        <a-row :gutter="24" style="margin-bottom:16px">
          <a-col :span="24">
            <div class="flex-row">
              <span style="margin-top:8px">合同附件：</span>
              <base-upload-file style="flex:1;" :fileList.sync="contractFileList" :disabled="true" />
            </div>
          </a-col>
        </a-row>
        <a-row :gutter="24" style="margin-bottom:16px">
          <a-col :span="24">
            <div class="flex-row">
              <span style="margin-top:8px">优惠附件：</span>
              <base-upload-file
                style="flex:1;"
                :fileList.sync="preferenceFileList"
                :disabled="true"
              />
            </div>
          </a-col>
        </a-row>
        <a-table
        style="margin-bottom:32px"
        :columns="columns"
        :dataSource="tableData"
        :rowKey="(record,index) => index"
        :pagination="false"
      ></a-table>
      </div>

      <a-row :gutter="24" type="flex" justify="center" style="margin-bottom:16px">
        <a-col>
          <a-button size="large" type="info" @click="$closeCurrentView()">取消</a-button>
        </a-col>
        <a-col>
          <a-button size="large" type="primary" :loading="submitLoading" @click="submit">提交</a-button>
        </a-col>
      </a-row>
    </a-spin>
    <choose-room
      :visible.sync="chooseRoomShow"
      :initialChecked="data.intoCodes"
      type="0"
      :id="companyIntoId"
      @change="chooseRoomChanged"
    />
  </div>
</template>

<script>
import moment from 'moment'
import ChooseRoom from '@/components/DialogChooseRoom'
import { investment } from '@/api'
export default {
  name: 'PageCompanyArchivesDetail',
  components: {
    ChooseRoom
  },
  data () {
    return {
      noRequireShow: true,
      dateFormat: 'YYYY-MM-DD',
      chooseRoomShow: false,
      loading: false,
      form: this.$form.createForm(this),
      data: {},
      companyIntoId: '',
      contractFileList: [],
      preferenceFileList: [],
      newFileList: [],
      submitLoading: false,
      tableData: [],
      columns: [
        {
          title: '缴费周期',
          dataIndex: 'rentDate'
        },
        {
          title: '费用名称',
          dataIndex: 'name'
        },
        {
          title: '单价',
          dataIndex: 'price'
        },
        {
          title: '应缴金额',
          dataIndex: 'receivableAmount'
        },
        {
          title: '优惠金额',
          dataIndex: 'preferentialAmount'
        },
        {
          title: '合计',
          dataIndex: 'receivedAmount'
        },
        {
          title: '状态',
          dataIndex: 'state',
          scopedSlots: {
            customRender: 'state'
          }
        },
        {
          title: '备注',
          dataIndex: 'remark'
        }
      ]
    }
  },
  async mounted () {
    if (this.$route.params.id) {
      this.companyIntoId = this.$route.params.id
    }
    this.loading = true
    await this.getData()
    this.loading = false
  },
  methods: {
    moment,
    handleFileInit (urls, names) {
      if (!urls || !names) return []
      let urlFormat = urls.split(',')
      let nameFormat = names.split(',')
      return urlFormat.length
        ? urlFormat.map((x, i) => ({
          url: x,
          name: nameFormat[i]
        }))
        : []
    },
    chooseRoomChanged (e) {
      this.data.intoCodes = e.roomChecked
      this.data.intoNames = e.checkedNames
      this.data.totalArea = e.totalArea
    },
    async getData () {
      const { code, data, msg } = await investment.getContractInfo({
        companyIntoId: this.companyIntoId
      })
      if (code === 0) {
        this.data = data
        data.effectDate = data.effectDate || ''
        this.contractFileList = this.handleFileInit(
          data.contractUrl,
          data.contractName
        )
        this.preferenceFileList = this.handleFileInit(
          data.preferenceUrl,
          data.preferenceName
        )
        this.tableData = data.children || []
      } else {
        this.$message.error(msg || '数据获取失败')
      }
    },
    onChangeDate (date, dateString) {
      this.data.effectDate = dateString
    },
    async submit (e) {
      if (!this.data.intoCodes) {
        return this.$message.error('请选择入住房间')
      }
      if (!this.newFileList.length) {
        return this.$message.error('请上传变更协议附件')
      }
      if (!this.data.effectDate) {
        return this.$message.error('请选择生效时间')
      }
      this.submitLoading = true
      let changeUrl = []
      let changeName = []
      this.newFileList.forEach(item => {
        changeUrl.push(item.url)
        changeName.push(item.name)
      })
      const param = {
        companyIntoId: this.companyIntoId,
        intoCodes: this.data.intoCodes,
        intoNames: this.data.intoNames,
        totalArea: this.data.totalArea,
        changeUrl: changeUrl.join(','),
        changeName: changeName.join(','),
        effectDate: this.data.effectDate
      }
      const { code, msg } = await investment.changeContractInfo(param)
      if (code === 0) {
        this.$bus.$emit('ContractInfo:updateList')
        this.$message.success('提交成功')
        this.submitLoading = false
        this.$closeCurrentView()
      } else {
        this.$message.error(msg || '数据获取失败')
      }
    }
  }
}
</script>
<style lang="less" scoped>
.head-title {
  margin: 24px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #dcdfe5;
  .title-text {
    color: #1890ff;
    font-weight: 500;
    padding: 10px 10px;
    font-size: 14px;
    border-bottom: 2px solid #1890ff;
  }
  .title-btn {
    margin-right: 16px;
  }
  .title-btn:last-child {
    margin-right: 0;
  }
}
.flex-row {
  display: flex;
  align-items: center;
}
.flex-row span {
  flex-shrink: 0;
  line-height: 18px;
}
.require {
  position: relative;
}
.require::after {
  content: "*";
  position: absolute;
  left: -8px;
  top: 6px;
  line-height: 12px;
  color: red;
}
.btn-control {
  cursor: pointer;
  font-size: 14px;
}
</style>
